import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
/** Meta Pixel */
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
;
(function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '837323995806328');
  window.fbq('track', 'PageView');
})();
render(<App data-id="element-300" />, document.getElementById('root'));